import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { StandardResponse } from 'src/app/shared/interfaces/generic-response';
import { ToastPrimeService } from 'src/app/shared/services/toast-prime.service';

export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const toasterMessage = inject(ToastPrimeService);

  return next(req).pipe(
    map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        const responseBody = event.body as StandardResponse<object>;
        if (
          responseBody?.status == 200 &&
          responseBody.message !== null &&
          responseBody.message !== undefined &&
          responseBody.message !== ''
        ) {
          toasterMessage.showSuccess(responseBody.message);
        } else if (
          responseBody.status !== 200 &&
          responseBody.message !== null &&
          responseBody.message !== undefined &&
          responseBody.message !== '' &&
          responseBody.status !== 500
        ) {
          toasterMessage.showErrorMessage(responseBody.message);
        } else if (responseBody.status === 500) {
          throw new Error('Internal server error');
        }
      }
      return event;
    }),
    catchError(error => {
      let errorMessage = error.message;
      if (error.status === 500) {
        errorMessage = 'Internal server error';
      }
      toasterMessage.showErrorMessage(errorMessage);

      throw error;
    }),
  );
};
